module.exports = __webpack_public_path__ + "static/media/rectangle.3a0d2153.png";